/**
 * Ear Training Suite URL-param parser. The route accepts a single `?mode`
 * parameter — `interval` or `quality` — used to pre-select the sub-mode card
 * on the welcome screen. Unknown / missing values return null so the welcome
 * screen renders with no pre-selection (user must pick).
 *
 * Spec: docs/superpowers/specs/2026-05-20-ear-training-suite-design.md §4.2
 */
export type SubMode = 'interval' | 'quality'

export const parseSubMode = (raw: string | null): SubMode | null => {
  if (raw === 'interval' || raw === 'quality') {
    return raw
  }
  return null
}
